/**
 * returns a stringified auth cookie
 */
 function getAuthHeader() {
  return getAuthCookie();
}

function getAuthCookie() {
  // get all the cookies from the browser
  const rawCookie = getCookie("hp");
  if (rawCookie) {
    return rawCookie;
  }
}

function IsUserLoggedIn() {
  const rawCookie = getCookie("hp");
  return rawCookie !== undefined && rawCookie !== null;
}

function getUserProperties() {
  const rootElement = document.querySelector('#root');
  // Get logged-in user's information
  if (rootElement && IsUserLoggedIn()) {
    const firstName = rootElement.getAttribute('data-first-name');
    const lastName = rootElement.getAttribute('data-last-name');
    const userId = rootElement.getAttribute('data-user-id');
    const avatarUrl = rootElement.getAttribute('data-avatar-url');

    return {
      firstName: firstName ?? false,
      lastName: lastName ?? false,
      userId: userId ?? false,
      avatarUrl: avatarUrl ?? false
    }
  }
}

function getOsBearerToken(){
  return window.localStorage.getItem('os_bt');
}

/**
 *
 * @param {string} name the name of the cookie to retrieve
 */
function getCookie(name) {
  // return the cookie with the matching name
  return (document.cookie.match("(^|;) *" + name + "=([^;]*)") || [])[2];
}

export { getAuthHeader, getAuthCookie, IsUserLoggedIn, getUserProperties, getOsBearerToken };
